import React from 'react';
import { Space, Tag } from 'antd';
import { ItineraryPortCallDto } from '@client/screens/estimates/details/helpers/types';
import CountryFlag from '@client/components/CountryFlag';

export const usePortOptions = (
	portCalls: Array<ItineraryPortCallDto>,
	actionFilters?: string[],
) => {
	if (!portCalls?.length) {
		return [];
	}

	const shouldInclude = (pc: typeof portCalls[number]) => {
		if (!actionFilters) {
			return pc;
		}

		return pc.actions?.some((a) => (actionFilters ?? []).includes(a.event));
	};

	return portCalls
		.filter(shouldInclude)
		.map((pc) => ({
			value: pc.id,
			label: (
				<Space>
					<Tag color={pc.estimated ? 'cyan' : 'geekblue'}>
						{pc.estimated ? 'Estimated' : 'Actual'}
					</Tag>
					<CountryFlag countryCode={pc.port.countryCode} />
					{pc.port.name}
				</Space>
			),
		}));
};
